<template>
  <v-text-field
      dense
      outlined
      :label="label"
      :readonly="readonly"
      :rules="inputRules"
      v-model="options"
      :disabled="disabled">
  </v-text-field>
</template>

<script>
export default {
  name: "PriceInput",
  props: {
    value: {
      type: Number|String,
    },
    label: {
      type: String,
      default :''
    },
    rules:{
      type: Array
    },
    disabled:{
      type: Boolean,
      default: false
    },
    readonly:{
      type: Boolean,
      default:false
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  computed: {
    options: {
      get: function () {
        return isNaN(parseFloat(this.value))?this.value:(this.value /100) + '' //将props中的typeId值赋给value
      },
      set: function (val) {
        this.$emit('modify', isNaN(parseFloat(val))?val:((parseFloat(val)*100).toFixed(0)) + '') //通过$emit触发父组件
      },
    },
    inputRules:{
      get: function () {
        let ruleList = [value=> ((!value && value !== 0)||((/^-?\d+\.?\d{0,2}$/.test(value)))) || '只能输入两位小数']
        if(this.rules && this.rules.length > 0){
          ruleList = this.rules.concat(ruleList);
        }
        return ruleList;
      }
    }
  },
}
</script>

<style scoped>

</style>